import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {LoadingController, ModalController} from "@ionic/angular";
import {AuthService} from "../../../services/auth.service";
import {Operation} from "../../../models/auth.model";
import {FormCompleteComponent} from "../form-complete/form-complete.component";
import {Router} from "@angular/router";

@Component({
  selector: 'app-form-login',
  templateUrl: './form-login.component.html',
  styleUrls: ['./form-login.component.scss'],
})
export class FormLoginComponent implements OnInit {
  form: FormGroup | undefined;
  isSend = false;
  resp: any;
  private loading: any;
  plus = true;

  constructor(
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private router: Router,
    private auth: AuthService
  ) { }

  async ngOnInit() {
    this.loading = await this.loadingCtrl.create({
      message: 'Loading...',
      spinner: 'circles',
    });
    this.form = new FormGroup({
      phone: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required]),
    });
  }

  modalDismiss() {
    this.modalCtrl.dismiss();
  }

  send() {
    this.form?.markAllAsTouched();
    if (this.form?.invalid) { return; }
    this.loading.present().then();
    this.isSend = true;
    this.auth.loginByPassword({
      phone: this.form?.get('phone')?.value.replace(/[\s\(\)\-]/g, ''),
      password: this.form?.get('password')?.value
    }).subscribe(async resp => {
      this.loading.dismiss().then();
      if (this.auth.isAuthenticated) {
        this.modalCtrl.dismiss().then();
        this.auth.isAuthenticated$.next(true);
        this.router.navigateByUrl(`/${this.auth.defaultPage}`, { state: {edit: true} }).then();
        return;
      }
      this.resp = resp;
      this.isSend = false;
    }, resp => {
      console.error(resp);
      this.resp = resp;
      this.isSend = false;
      this.loading.dismiss().then();
    });
  }

  async sendSmsCode(): Promise<any> {
    this.form?.get('phone')?.markAllAsTouched();
    this.form?.get('password')?.reset();
    if (this.form?.get('phone')?.invalid) { return; }
    this.loading.present().then();
    this.isSend = true;
    this.auth.loginOrRegistrationBySms(Operation.ByPhone, this.form?.get('phone')?.value.replace(/[\s\(\)\-]/g, '')).subscribe(async resp => {
      this.resp = resp;
      if (this.resp?.messages?.length > 0) {
        this.loading.dismiss().then();
        this.isSend = false;
        return;
      }
      const modal = await this.modalCtrl.create({
        component: FormCompleteComponent,
        cssClass: 'login-modal',
        backdropDismiss: false,
        componentProps: {
          'operation': Operation.ByPhone,
        }
      });
      this.loading.dismiss().then();
      modal.present().then();
      this.isSend = false;
    }, resp => {
      console.error(resp);
    });
  }
}
